import { requestRaw } from './index';

// The consent and connected apps screens handle every error themselves (401
// included), so these calls use requestRaw. Ids are opaque values: they are
// always encoded as a single path segment.
function authorizationRequestPath(requestId) {
  return `/api/mcp/authorization-requests/${encodeURIComponent(requestId)}`;
}

export function getAuthorizationRequest(requestId) {
  return requestRaw({
    method: 'GET',
    path: authorizationRequestPath(requestId),
  });
}

export function approveAuthorizationRequest(requestId, scopes) {
  return requestRaw({
    method: 'POST',
    path: `${authorizationRequestPath(requestId)}/approve`,
    body: { scopes },
  });
}

export function denyAuthorizationRequest(requestId) {
  return requestRaw({
    method: 'POST',
    path: `${authorizationRequestPath(requestId)}/deny`,
  });
}

export function listGrants() {
  return requestRaw({
    method: 'GET',
    path: '/api/mcp/grants',
  });
}

export function revokeGrant(grantId) {
  return requestRaw({
    method: 'DELETE',
    path: `/api/mcp/grants/${encodeURIComponent(grantId)}`,
  });
}
